module.exports = __webpack_public_path__ + "img/testFTM.6d7c6dd1.svg";